//
//  SDKDocumentationLegacyCalloutType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var DocumentationLegacyCalloutType;
(function (DocumentationLegacyCalloutType) {
    DocumentationLegacyCalloutType["info"] = "Info";
    DocumentationLegacyCalloutType["success"] = "Success";
    DocumentationLegacyCalloutType["warning"] = "Warning";
    DocumentationLegacyCalloutType["error"] = "Error";
    DocumentationLegacyCalloutType["primary"] = "Primary";
})(DocumentationLegacyCalloutType || (DocumentationLegacyCalloutType = {}));
